import { defineMessages } from 'react-intl';

export default defineMessages({
  phase1: 'Locked KLAY/KLAP',
  depositButton: 'Deposit Now',
  approve: 'Approve',
  liquidityDropMsg: 'Liquidity Drop extra rewards accrue once a week, and you can claim weekly',
});
